import { render, staticRenderFns } from "./SimilarProducts.vue?vue&type=template&id=4655c5c6"
import script from "./SimilarProducts.vue?vue&type=script&lang=js"
export * from "./SimilarProducts.vue?vue&type=script&lang=js"
import style0 from "./SimilarProducts.vue?vue&type=style&index=0&id=4655c5c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports